import store from './applications-store';
import routes from './applications-routes';

export default {
    components: [],
    routes,
    store,
};
